import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '@/services/fa-inventory-api';
import type { ScanResult } from '@/services/fa-inventory-api';

export function useInventoryRuns() {
  return useQuery({
    queryKey: ['fa-inventory', 'runs'],
    queryFn: api.fetchInventoryRuns,
    staleTime: 30_000,
  });
}

export function useScanAsset(runId: string | null) {
  const qc = useQueryClient();
  return useMutation<ScanResult, Error, string>({
    mutationFn: async (assetNumber: string) => {
      if (!runId) throw new Error('No active inventory run');
      return api.scanAsset(runId, assetNumber);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['fa-inventory', 'runs'] });
    },
  });
}

export function useCompleteRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (runId: string) => api.completeRun(runId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['fa-inventory', 'runs'] });
    },
  });
}
